<template>
  <div class="account-warpper">
    <div class="bg-white ">
      <div class="margin-bottom-sm flex align-center justify-between">
        <div class="flex align-center">
          <div class="margin-right" v-if="[3,5].includes(user.power)">
            <el-button type="primary" >志愿者</el-button>
            <router-link to="/home/team-admin" ><el-button type="primary" plain >志愿者队长</el-button></router-link>
          </div>

          <div class="flex align-center margin-right-sm">
            <span>姓名：</span>
            <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm">
            <span>手机号：</span>
            <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <el-button
          type="warning"
          @click="exportWuyeguanjiaList"
        >导出志愿者信息
        </el-button>
      </div>
      <el-table
        :data="accountList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="志愿者" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="username"></el-table-column>
        <el-table-column label="完成的服务项数" prop="service_num"></el-table-column>
        <el-table-column label="积分" prop="integral"></el-table-column>
<!--        <el-table-column label="金暖宝" prop="jinnuanbao"></el-table-column>-->
<!--        <el-table-column label="银暖宝" prop="yinnuanbao"></el-table-column>-->
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                size="small"
                type="primary"
                @click="detailItem(scope.row.id)"
              >查看
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="detailHomeItem(scope.row.id,scope.row.name)"
              >家庭成员
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="accountList.length > 0"
        class="page-all"
        background
        @current-change="getAdminList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {powerTypes} from "@/utils/utils";
import {exportWuyeguanjiaList, getWuyeguanjiaList} from "@/api/weilao";
export default {
  name: "account",
  data() {
    return {
      name: '',
      phone: '',
      page: 1,
      limit: 10,
      total: 0,
      accountList: [],
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 志愿者", false);
    this.getAdminList()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
  },
  methods: {
    //  志愿者队长数据导出
    async exportWuyeguanjiaList(){
      let _state = await exportWuyeguanjiaList(
        this.name,
        this.phone,
        8
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '志愿者数据.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  志愿者详情
    detailItem(id){
      this.$router.push('/home/team-member-detail/' + id)
    },
    //  家庭成员
    detailHomeItem(id,name){
      this.$router.push('/home/team-member-home/' + id + '?name=' + name)
    },
    //  搜索
    hanldSearch(){
      this.page = 1
      this.getAdminList()
    },
    //  获取列表
    async getAdminList() {
      let _list = await getWuyeguanjiaList(
        this.name,
        this.phone,
        8,
        this.page,
        this.limit,
      )
      this.accountList = _list.data?_list.data:[]
      this.total = _list.total_number
    }
  },
  filters: {
    power(val){
      return powerTypes(val)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
